import React, { Fragment } from "react"
import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"
import { Margin, mb, pb } from "styled-components-spacing"

import backArrow from "../../images/arrow-left.svg"
import { ButtonResetCSS } from "../atoms/Buttons"
import { H4 } from "../atoms/Headings"
import { Link } from "../atoms/Link"

const LinkResolver = require("../../utils/linkResolver")

export const BackButton = styled.button`
  ${ButtonResetCSS};
  background: url("${backArrow}") left calc(50% + 2px) no-repeat;
  background-size: 17px;
  padding: 0 0 0 24px;
  cursor: pointer;

  :active {
    outline: none;
  }
`
export function Creators({ createdBy }) {
  if (createdBy?.length) {
    return (
      <Margin bottom={2}>
        <H4>Created by</H4>
        {createdBy.map((creator, i) => {
          const slug = creator.slug
          /* <Link to={LinkResolver(creator.internal.type, slug)}>
            {creator.title}
          </Link> */

          const Ln = <span>{creator.name}</span>
          // console.log(creator, createdBy)
          let ret
          if (createdBy.length === 1) ret = Ln
          if (createdBy.length === 2) ret = i === 0 ? Ln : <> and {Ln}</>
          if (createdBy.length > 2)
            ret = i === createdBy.length - 1 ? <>and {Ln}</> : <>{Ln}, </>
          // console.log(ret)
          return <Fragment key={slug}>{ret}</Fragment>
        })}
      </Margin>
    )
  }

  return null
}

const Tag = styled(Link)`
  border-radius: 4px;
  background: ${props => props.theme.colors.ash};
  padding: 1px 10px;
`

export function Categories({ type, ecosystem }) {
  const categories = []

  if (type?.length) {
    type.forEach(t => {
      if (t === "Dashboard") {
        categories.push(
          <Tag key={t} to={LinkResolver("KPIWorkbookList", t)}>
            {t}
          </Tag>
        )
      } else {
        categories.push(
          <Tag key={t} to={LinkResolver("TemplateList", t)}>
            {t}
          </Tag>
        )
      }
    })
  }
  if (ecosystem) {
    categories.push(
      <Tag key={ecosystem} to={LinkResolver("TemplateEcoSystem", ecosystem)}>
        {ecosystem}
      </Tag>
    )
  }
  return categories.length > 0 ? (
    <Margin bottom={2}>
      <H4>Categories</H4>
      <div
        css={css`
          display: flex;
          flex-flow: wrap;
          ${Tag} {
            margin-right: 5px;
            margin-top: 5px;
          }
        `}
      >
        {categories}
      </div>
    </Margin>
  ) : null
}

export function RelatedArticles({ relatedPosts }) {
  return relatedPosts?.length > 0 ? (
    <Margin bottom={2}>
      <H4>Related Resource{relatedPosts.length > 1 && `s`}</H4>
      {relatedPosts.map(post => (
        <a
          key={post.slug}
          target="_blank"
          href={`https://karbonhq.com/resources/${post.slug}`}
          css={css`
            display: block;
            line-height: 1.1;
            ${mb(1)}
          `}
          rel="noreferrer"
        >
          {post.title}
        </a>
      ))}
    </Margin>
  ) : null
}

export function SupportArticles({ supportArticles }) {
  return supportArticles?.length > 0 ? (
    <Margin bottom={2}>
      <H4>Support</H4>
      {supportArticles.map(post => (
        <a
          target="_blank"
          href={post.url}
          key={post.url}
          css={css`
            display: block;
            line-height: 1.1;
            ${mb(1)}
          `}
          rel="noreferrer"
        >
          {post.title}
        </a>
      ))}
    </Margin>
  ) : null
}

export const Header = styled(Margin)`
  display: grid;
  grid-template-columns: 56px 1fr;
  grid-column-gap: 16px;
  border-bottom: 1px solid ${props => props.theme.colors.lightGrey};
  ${pb(3)};

  ${breakpoint("sm")(
    () => css`
      grid-template-columns: 80px 1fr;

      ${pb(4)};
    `
  )}
`
export const TwoUp = styled(Margin)`
  display: grid;
  grid-gap: 20px;
  border: 1px solid ${props => props.theme.colors.ash};
  border-radius: 4px;

  ${breakpoint("md")(
    () => css`
      grid-template-columns: 1fr 1fr;
    `
  )}

  > div {
    padding: 32px 24px;
  }

  .add {
    background: ${props => props.theme.colors.ash};
  }
`
export const MetaContainer = styled.div`
  ${mb(4)};

  .show {
    ${breakpoint("xl")(
      css`
        display: none;
      `
    )}
  }

  > div {
    display: none;
    ${breakpoint("xl")(
      css`
        display: block;
      `
    )}
  }

  &.showing > div {
    display: block;
  }
`
export const TemplatePageBody = styled.div`
  display: grid;

  ${breakpoint("xl")(
    () => css`
      grid-template-columns: [main] 1fr [main-end sidebar] 235px [sidebar-end];
      grid-column-gap: 40px;

      ${MetaContainer} {
        grid-row: 1 / span 2;
        grid-column: sidebar / sidebar-end;
      }
    `
  )}
`
